<template>
  <el-card class="box-card">
    <div class="header">
      <img src="../assets/imgs/logo.png" alt="" />
    </div>
    <div class="content">
      <el-form
        ref="smsLoginForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        label-position="top"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="图形验证码" prop="captcha">
          <div class="code-box">
            <el-input
              v-model="form.captcha"
              placeholder="请输入图形验证码"
            ></el-input>
            <div @click="getCaptchaCode" class="captcha-box">
              <div class="loading-img" v-if="codeLoading"><van-loading /></div>

              <img v-else :src="captchaUrl" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="短信验证码" prop="captcha">
          <div class="code-box">
            <el-input
              v-model="form.smsCode"
              placeholder="请输入短信验证码"
            ></el-input>
            <div
              @click="getSMSCode"
              class="get-code"
              :class="{ disabled: countdown > 0 }"
            >
              {{ countdown > 0 ? `${countdown}s后重新获取` : "获取验证码" }}
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="input-box">
        <div class="sms-login" @click="assignLoginType()">账号密码登录</div>
      </div>
    </div>
    <div class="footer">
      <div class="login gradient-background" @click="handleSmsLogin">
        登录<el-icon v-if="loading"><Loading /></el-icon>
      </div>
    </div>
  </el-card>
  <div></div>
</template>

<script>
import { Loading } from "@element-plus/icons-vue";
export default {
  name: "PcsmsLogin",
  components: {
    Loading,
  },
  data() {
    return {
      form: {
        captchaId: "",
        captcha: "",
        phone: "",
        smsCode: "",
      },
      countdown: 0,
      timer: null,
      captchaUrl: "",
      codeLoading: false,
      loading: false,
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        captcha: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    assignLoginType() {
      const data = {
        phone: this.form.phone,
      };
      this.$emit("assignLoginType", "1", data);
    },
    async getCaptchaCode() {
      this.codeLoading = true;
      try {
        // 清理旧的 URL，避免内存泄漏
        if (this.captchaUrl) {
          URL.revokeObjectURL(this.captchaUrl);
          this.captchaUrl = "";
        }
        const res = await this.$https.getBlob("/api/captcha");
        const blob = res && (res.blob || res);
        const headers = (res && res.headers) || {};
        const contentType = headers["content-type"] || "image/png";
        const finalBlob =
          blob instanceof Blob ? blob : new Blob([blob], { type: contentType });
        this.captchaUrl = URL.createObjectURL(finalBlob);
        // 提取 captchaId（若存在）
        const lowerHeaders = {};
        Object.keys(headers).forEach(
          (k) => (lowerHeaders[k.toLowerCase()] = headers[k])
        );
        this.form.captchaId = lowerHeaders["captcha-id"] || "";
      } catch (error) {
        this.$Toast(error.message);
      } finally {
        this.codeLoading = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    async getSMSCode() {
      //   if (this.countdown > 0) {
      //     return;
      //   }

      //   if (!this.form.phone) {
      //     this.$Toast("请输入手机号码");

      //     return;
      //   }
      //   if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
      //     this.$Toast("请输入正确的手机号码");
      //     return;
      //   }
      //   // 校验图形验证码
      //   if (!this.form.captcha) {
      //     this.$Toast("请输入图形验证码");
      //     return;
      //   }
      const valid = await this.$refs.smsLoginForm.validate();
      if (!valid) return;

      try {
        const res = await this.$https.post("/api/sms/sign-in", {
          phone: this.form.phone,
          captchaId: this.form.captchaId,
          captcha: this.form.captcha.trim(),
        });
        this.startCountdown();
      } catch (error) {
        this.$Toast(error.message);
      }
    },
    commonLogin(res) {
      if (res.success) {
        const data = res.data;
        sessionStorage.setItem("userInfo", JSON.stringify(data));
        this.$router.replace({
          path: "/home",
        });
      } else {
        this.loading = false;
        this.$message.error(res.message);
      }
    },

    // 短信
    async handleSmsLogin() {
      if (this.loading) return;

      const valid = await this.$refs.smsLoginForm.validate();
      if (!valid) return;
      this.loading = true;
      const params = {
        ...this.form,
        smsCode: this.form.smsCode.trim(),
        captcha: this.form.captcha.trim(),
      };

      try {
        const res = await this.$https.post("/api/login-sms", params);
        if (res && res.success) {
          this.commonLogin(res);
        } else {
          this.$Toast(res && res.message ? res.message : "登录失败");
        }
      } catch (error) {
        this.getCaptchaCode();
        this.$Toast(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getCaptchaCode();
  },
};
</script>

<style scoped lang="less">
.content {
  //   width: 400px;
  //   margin: 0 auto;
  .code-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .el-input {
      flex: 1;
      margin-right: 10px;
    }
    img {
      width: 110px;
      height: 44px;
    }
    .captcha-box {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .loading-img {
      width: 110px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .get-code {
      color: #088ed2;
      font-size: 18px;
      cursor: pointer;
      // width: 100px;
      padding: 5px 10px;
      border: 1px solid #088ed2;
      border-radius: 5px;
      transition: all 0.3s ease;
      white-space: nowrap;

      &.disabled {
        color: #ccc;
        border-color: #ccc;
        cursor: not-allowed;
        background-color: #f5f5f5;
      }
    }
  }
}

// 小屏幕适配
@media screen and (max-width: 600px) {
  .content {
    .code-box {
      img {
        width: 90px;
        height: 36px;
      }
      .loading-img {
        width: 90px;
        height: 32px;
      }
      .get-code {
        font-size: 14px;
        padding: 4px 8px;
      }
    }
  }
}

// 超小屏幕适配
@media screen and (max-width: 400px) {
  .content {
    .code-box {
      img {
        width: 80px;
        height: 32px;
      }
      .loading-img {
        width: 80px;
        height: 28px;
      }
      .get-code {
        font-size: 12px;
        padding: 3px 6px;
      }
    }
  }
}
</style>
